/**
 * DictTips — тексты справок-«?» секций Справочников: эталон
 * screen-21-dicts.js:399-425 ДОСЛОВНО (продуктовая спека связей и жестов).
 * Единственное отступление — Д2: перечень потребителей карточки дополнен
 * «услугами» (эталон смешивал услуги в словарь квестов, мы раскладываем
 * честно — четвёртый блок cblk). Рендерится внутрь TipBox (стили p/b —
 * prices.module.css .tipbox).
 */
import type { DictKind } from "../../hooks/useDictsAdmin";

export function DictTips({ kind }: { kind: DictKind }) {
  if (kind === "c") {
    return (
      <>
        <p>Справочники <b>общесетевые</b> — филиалов нет. Из них квесты и услуги выбирают позиции.</p>
        <p><b>Тап</b> — карточка мини-склада: стоимость за единицу, потребители (квесты · чайные · операторы · услуги) и история покупок с чеками. Связи двусторонние: заданное в квесте видно тут.</p>
        <p>Счётчик «в N» суммирует всех потребителей.</p>
        <p><b>Фильтры</b> в заголовке — филиал и квест: показывают позиции, которые потребляет выбор.</p>
        <p><b>Свайп вправо</b> — дубликат: откроется форма копии.</p>
        <p><b>✕</b> удаляет сразу — внизу 5 секунд можно ОТМЕНИТЬ; используемая позиция — с предупреждением.</p>
        <p><b>Потяните вниз</b> от верха списка — обновить данные.</p>
      </>
    );
  }
  return (
    <>
      <p>Ресурсы <b>общесетевые</b>, без норм — квест или услуга просто занимает ресурс.</p>
      <p><b>Тап</b> — карточка: стоимость, привязки (квесты · услуги) и история покупок с медиа. Связи двусторонние с формами квестов и услуг.</p>
      <p><b>Фильтры</b> — филиал и квест: потребление выбором плюс собственная привязка ресурса к филиалу.</p>
      <p><b>Свайп вправо</b> — дубликат.</p>
      <p><b>✕</b> удаляет сразу — 5 секунд можно ОТМЕНИТЬ; используемый — с предупреждением.</p>
      <p><b>Потяните вниз</b> от верха списка — обновить данные.</p>
    </>
  );
}
